import React, { useState } from "react";
import styled, { css } from "styled-components";
import { IfPermitted } from "components/common";
import { Col, Row } from "components/bootstrap";
import CollectionEntitiesList from "./CollectionEntitiesList/CollectionEntitiesList";
import AddEntitiesModal from "./AddEntitiesModal";
const EntitiesHeaderCol = styled(Col)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.spacings.sm};
  `
);
const CollectionDetails = ({ collection }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  return /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `collection_entities:list:${collection.id}` }, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(EntitiesHeaderCol, { md: 12 }, /* @__PURE__ */ React.createElement("h2", null, "Collection Content"))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(CollectionEntitiesList, { collectionId: collection.id, collectionTitle: collection.title }))))), showAddModal && /* @__PURE__ */ React.createElement(AddEntitiesModal, { collectionId: collection.id, onClose: () => setShowAddModal(false) }));
};
export default CollectionDetails;
